<template>
    <div>
        <!-- ========== HEADER ========== -->
        <header id="header" class="u-header">
            <div class="u-header__section">
                <TopBar/>

                <div id="logoAndNav" class="container">
                    <!-- Nav -->
                    <nav class="js-mega-menu navbar navbar-expand-md u-header__navbar u-header__navbar--no-space">
                        <Logo/>

                    </nav>
                    <!-- End Nav -->
                </div>
            </div>
        </header>
        <!-- ========== END HEADER ========== -->

        <!-- ========== MAIN ========== -->
        <main id="content" role="main">

            <EditProfileInvite v-if="auth_user.username === username"/>

            <FlexLoader v-if="$apollo.queries.user.loading"/>
            <ViewProfileInfo v-else :userInfo="user"/>

            <!-- Blog Listing Section -->
            <div id="postsSection" class="container space-2 space-bottom-lg-3">
                <div class="row">
                    <div id="stickyBlockStartPoint" class="col-lg-3 u-ver-divider u-ver-divider--none-lg mb-7 mb-lg-0">
                        <div class="js-sticky-block mr-lg-3" data-parent="#stickyBlockStartPoint"
                             data-sticky-view="md"
                             data-start-point="#stickyBlockStartPoint"
                             data-end-point="#stickyBlockEndPoint"
                             data-offset-top="24"
                             data-offset-bottom="24">
                            <div class="navbar-expand-lg navbar-expand-lg-collapse-block">
                                <div id="sidebarNav" class="collapse navbar-collapse">
                                    <div class="mt-5 mt-lg-0">
                                        <h2 class="h6 font-weight-semi-bold">Posts</h2>

                                        <!-- List Group -->
                                        <ul class="list-group list-group-flush list-group-borderless mb-0">
                                            <li>
                                                <a class="list-group-item d-flex
                                                justify-content-between align-items-center" href="#postsSection"
                                               v-bind:class="{'list-group-item-action':!(postSelectorVal === POST_SELECTOR.published)}"
                                               @click="setPostSelectorVal(POST_SELECTOR.published)">
                                                    Publiés
<!--                                                    <span class="badge border badge-pill">30+</span>-->
                                                </a>
                                            </li>
                                            <li>
                                                <a class="list-group-item d-flex justify-content-between
                                                align-items-center" href="#postsSection"
                                                   v-bind:class="{'list-group-item-action':!(postSelectorVal === POST_SELECTOR.pinned)}"
                                                   @click="setPostSelectorVal(POST_SELECTOR.pinned)">
                                                    Épinglés
                                                </a>
                                            </li>
                                        </ul>
                                        <!-- End List Group -->
                                    </div>

                                    <div class="mt-5">
                                        <h3 class="h6 font-weight-semi-bold">Catégories</h3>

                                        <!-- List Group -->
                                        <ul class="list-group list-group-flush list-group-borderless mb-0">
                                            <li>
                                                <a class="list-group-item d-flex justify-content-between align-items-center" href="#postsSection"
                                                   v-bind:class="{'list-group-item-action':!(categoryFilterVal === CATEGORY_FILTER.all)}"
                                                   @click="setCategoryFilterVal(CATEGORY_FILTER.all)">
                                                    Toutes
                                                </a>
                                            </li>
                                            <li>
                                                <a class="list-group-item d-flex justify-content-between align-items-center" href="#postsSection"
                                                   v-bind:class="{'list-group-item-action':!(categoryFilterVal === CATEGORY_FILTER.need)}"
                                                   @click="setCategoryFilterVal(CATEGORY_FILTER.need)">
                                                    Besoin
                                                </a>
                                            </li>
                                            <li>
                                                <a class="list-group-item d-flex justify-content-between align-items-center" href="#postsSection"
                                                   v-bind:class="{'list-group-item-action':!(categoryFilterVal === CATEGORY_FILTER.announcement)}"
                                                   @click="setCategoryFilterVal(CATEGORY_FILTER.announcement)">
                                                    Annonce
                                                </a>
                                            </li>
                                        </ul>
                                        <!-- End List Group -->
                                    </div>

                                    <hr class="mt-5 mb-3">

                                    <div class="mt-5">
                                        <h3 class="h6 font-weight-semi-bold">Tags</h3>

                                        <!-- List Group -->
                                        <ul class="list-group list-group-flush list-group-borderless mb-0">
                                            <li>
                                                <a class="list-group-item d-flex justify-content-between
                                                align-items-center" href="#postsSection"
                                                   v-bind:class="{'list-group-item-action':!(user_item_to_display === ITEM.favoriteTags)}"
                                                   @click="setItemToDisplay(ITEM.favoriteTags)">
                                                    Favoris
                                                </a>
                                            </li>
                                        </ul>
                                        <!-- End List Group -->
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-7 col-lg-8 mb-7 mb-md-0">
                        <FlexLoader v-if="$apollo.queries.user.loading"/>
                        <post-list v-else-if="user_item_to_display === ITEM.posts" :posts="displayedPosts"/>
                        <TagsView v-else-if="user_item_to_display === ITEM.favoriteTags" :tags="favoriteTags"/>

                        <!-- Sticky Block End Point -->
                        <div id="stickyBlockEndPoint"></div>

                        <div class="space-bottom-2"></div>
                    </div>

                    <script type="application/javascript" v-bind:src="hsSticky.script"></script>
                    <script type="application/javascript" v-bind:src="hsSticky.pluginInit"></script>
                </div>
            </div>
            <!-- End Blog Listing Section -->
        </main>
        <!-- ========== END MAIN ========== -->

        <FooterA/>

        <GoToTop/>
    </div>
</template>

<script>

    import GoToTop from "../components/GoToTop";
    import TopBar from "../components/TopBar";
    import FooterA from "../components/FooterA";
    import Logo from "../components/Logo";
    import PostList from "../components/PostList";
    import ViewProfileInfo from "../components/ViewProfileInfo";
    import EditProfileInvite from "../components/EditProfileInvite";
    import TagsView from "../components/TagsView";
    import {GET_USER} from "../settings/graphql";
    import {POST_CATEGORIES, USER_POST_SELECTOR, USER_ITEM_TO_DISPLAY} from "../settings";
    import FlexLoader from "../components/FlexLoader";
    import {JS_FILES} from "../settings/scripts";

    export default {
        name: "ViewProfile",
        components: {FlexLoader, EditProfileInvite, ViewProfileInfo, PostList, Logo, FooterA, TopBar, GoToTop, TagsView},
        data() {
            return {
                auth_user: this.$store.state.user.info,
                username: this.$route.params.username,
                user: null,
                publishedPosts: [],
                pinnedPosts: [],
                favoriteTags: [],
                CATEGORY_FILTER: POST_CATEGORIES,
                categoryFilterVal: POST_CATEGORIES.all,
                POST_SELECTOR: USER_POST_SELECTOR,
                postSelectorVal: USER_POST_SELECTOR.published,
                ITEM: USER_ITEM_TO_DISPLAY,
                user_item_to_display: USER_ITEM_TO_DISPLAY.posts,
                hsSticky: JS_FILES.hs.sticky
            }
        },
        apollo: {
            user: {
                query: GET_USER,
                fetchPolicy: 'cache-and-network',
                variables() {
                    return {
                        username: this.username,
                    }
                },
                update(data){
                    const info = data.users.edges[0].node;
                    // console.log(`User info retrieved: ${JSON.stringify(info)}`);
                    this.setPinnedPosts(info.postPinnedSet);
                    this.setPublishedPosts(info.postSet);
                    this.setFavoriteTags(info.tagFavoriteSet);
                    return info;
                }
            }
        },
        methods: {
            setPublishedPosts(posts) {
                this.$data.publishedPosts = posts;
            },
            setPinnedPosts(posts) {
                this.$data.pinnedPosts = posts;
            },
            setItemToDisplay(item){
                this.$data.user_item_to_display = item;
            },
            setCategoryFilterVal(value) {
                this.$data.categoryFilterVal = value;
                this.setItemToDisplay(this.$data.ITEM.posts);
            },
            setPostSelectorVal(value) {
                this.$data.postSelectorVal = value;
                this.setItemToDisplay(this.$data.ITEM.posts);
            },
            setFavoriteTags(tags) {
                this.$data.favoriteTags = tags;
            }
        },
        computed: {
            displayedPosts: function () {
                let posts = {edges: []};

                if (this.postSelectorVal === this.POST_SELECTOR.published){
                    posts = this.publishedPosts;
                }
                else if (this.postSelectorVal === this.POST_SELECTOR.pinned){
                    posts = this.pinnedPosts;
                }

                let filteredEdges = posts.edges;

                // filter by category
                const categoryFilterVal = this.categoryFilterVal;

                if(categoryFilterVal !== POST_CATEGORIES.all){
                    filteredEdges = filteredEdges.filter(function(edge){
                        return edge.node.category === categoryFilterVal;
                    });
                }

                return {
                    edges: filteredEdges,
                    __typename: posts.__typename
                };
            }
        },
        beforeRouteUpdate (to, from, next) {
          this.$data.username = to.params.username;
          this.$apollo.queries.user.refresh();
          next();
        }
    }
</script>

<style scoped>

</style>